export const iconFontAwesomeCommunicationEarListen = (
	<i className="fa-solid fa-ear-listen"></i>
);
